import { observable, action } from 'mobx'
import { QuestionnaireMode } from '../configs/constant'
import { SelectedFileResponse } from '../hooks/useQuestionnaireFile'
import { LinkDataResponse } from '../hooks/useQuestionnaireLink'

type QuestionnaireListObj = {
    key: string
    id: string | number | undefined
    value: string[] | number[] | null
    file: SelectedFileResponse[]
    link: LinkDataResponse[]
    suggestion: string | null
}
type questionnaireUploadIndex = {
    dimensionIndex: number | null
    purposeIndex: number | null
    questionIndex: number | null
}

export default class {
    @observable questionnaireList: QuestionnaireListObj[] = []
    @action setQuestionnaireList = (key: string, questionnaireList: QuestionnaireListObj[]) => {
        const indexQuestionnaireList = this.questionnaireList.findIndex((item) => item.key === key)
        if (indexQuestionnaireList === -1) {
            this.questionnaireList = [...this.questionnaireList, ...questionnaireList]
        } else {
            this.questionnaireList[indexQuestionnaireList] = questionnaireList[0]
        }
    }

    @action resetQuestionnaire = () => {
        this.questionnaireList = []
        this.isCopyLinkAndFile = false
        this.isUpFileFinish = false
    }

    @observable isUpFileFinish: boolean = false
    @action setIsUpFileFinish = (isUpFileFinish: boolean) => {
        this.isUpFileFinish = isUpFileFinish
    }

    @action reSetIsUpFileFinish = () => {
        this.isUpFileFinish = false
    }

    @observable isCopyLinkAndFile: boolean = false
    @action setIsCopyLinkAndFile = (isCopyLink: boolean) => {
        this.isCopyLinkAndFile = isCopyLink
    }

    @observable takeQuestionnaireMode: QuestionnaireMode = QuestionnaireMode.todo
    @action setTakeQuestionnaireMode = (mode: QuestionnaireMode) => {
        this.takeQuestionnaireMode = mode
    }

    @observable questionnaireUploadIndex: questionnaireUploadIndex = {
        dimensionIndex: null,
        purposeIndex: null,
        questionIndex: null,
    }
    @action setQuestionnaireUploadIndex = (value: questionnaireUploadIndex) => {
        this.questionnaireUploadIndex = value
    }
    @action resetQuestionnaireUploadIndex = (value: questionnaireUploadIndex) => {
        this.questionnaireUploadIndex = {
            dimensionIndex: null,
            purposeIndex: null,
            questionIndex: null,
        }
    }

    @observable selectedQuestionnaire: { questionnaireName: string; commuName: string } = {
        questionnaireName: '',
        commuName: '',
    }

    @action setSelectedQuestionnaire = (value: { questionnaireName: string; commuName: string }) => {
        this.selectedQuestionnaire = value
    }

    @action resetSelectedQuestionnaire = () => {
        this.selectedQuestionnaire = {
            questionnaireName: '',
            commuName: '',
        }
    }

    @observable currentStep = 0
    @observable historySteps: number[] = [0]
    @action setStep = (step: number) => {
        const findNumber = this.historySteps.find((item) => item === step)

        this.currentStep = step

        if (!findNumber) {
            this.historySteps.push(step)
        }
    }

    @action resetStep = () => {
        this.currentStep = 0
        this.historySteps = [0]
    }
}
